<script setup lang="ts">
  import { computed } from 'vue'

  import { useI18n } from 'vue-i18n'

  import CPButton from '@ui/components/CPButton.vue'
  import CPText from '@ui/components/CPText.vue'

  const props = defineProps({
    recipientName: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: 'chat-blocked',
    },
    containerClass: {
      type: String,
      default: 'px-3',
    },
  })

  const emit = defineEmits<{
    unblock: []
  }>()

  defineOptions({
    name: 'ChatConversationBlockedNotice',
  })

  const { t } = useI18n()

  const displayName = computed(() => {
    return props.recipientName || t('chats.user.unknownUser')
  })

  const message = computed(() => {
    return t('chats.blockedNotice.message', { name: displayName.value })
  })

  const unblockButtonId = computed(() => `${props.idPrefix}-unblock`)
</script>

<template>
  <div class="border-t border-default bg-surface py-2" :class="containerClass">
    <CPText size="xs" weight="regular" class="text-danger">
      {{ message }}
    </CPText>
    <div class="mt-3">
      <CPButton :id="unblockButtonId" type="secondary" size="sm" class="w-full" @click="emit('unblock')">
        {{ t('chats.blockedNotice.unblockNow') }}
      </CPButton>
    </div>
  </div>
</template>
